import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Tooltip } from '../index.js';
export const CopyTooltipLayout = memo(function CopyTooltipLayout({ children, copiedTooltip, feedbackVisible, hintVisible, onHintVisibleChange, tooltip, disabled, }) {
    return (_jsx(Tooltip, { tooltip: tooltip, trigger: 'hover', placement: 'top', disabled: disabled || feedbackVisible, onVisibleChange: onHintVisibleChange, visible: hintVisible, children: _jsx(Tooltip, { tooltip: copiedTooltip, visible: feedbackVisible, delayShow: 0, placement: 'top', disabled: disabled, children: children }) }));
});
